import LanguageToggle from '../../src/legacy/LanguageToggle';
export default LanguageToggle;
